<template>
  <div class="main">
    <HeaderTitle title="Dashboard">
      <IconHome size="w-10 h-10" color="#14444f" />
    </HeaderTitle>
    <MainContent>
      <div class="flex flex-col pt-3">
        <h3 class="text-sm text-greenPrimary font-semibold">Hello, Welcome Back</h3>
        <h2 class="text-lg text-greenPrimary font-bold">
          {{ user.name.toUpperCase() }}
        </h2>
      </div>
      <div class="pt-3 pb-5">
        <div class="flex gap-8">
          <CardDetail
            menu="Total Feature"
            :detail="total.total_feature"
            background="bg-blue-200"
            :loading="total.loading"
            @viewMore="viewDetail('Feature')"
          />
          <CardDetail
            menu="Total Scene"
            :detail="total.total_scene"
            :loading="total.loading"
            background="bg-green-200"
            text="text-green-800"
            bgButton="bg-green-200"
            textColor="text-green-800"
            hover="hover:bg-green-300"
            @viewMore="viewDetail('Scene')"
          />
        </div>

        <div class="flex gap-8 pt-8">
          <CardDetail
            menu="Total Post Order"
            :detail="total.total_post_order"
            :loading="total.loading"
            background="bg-purple-200"
            text="text-purple-800"
            bgButton="bg-purple-200"
            textColor="text-purple-800"
            hover="hover:bg-purple-300"
            @viewMore="viewDetail('Post Order')"
          />
          <CardDetail
            menu="Jumlah Dipesan"
            :detail="total.jumlah_dipesan"
            :loading="total.loading"
            background="bg-[#f9c369]"
            text="text-[#8C4C1F]"
            bgButton="bg-[#f9c369]"
            textColor="text-[#8C4C1F]"
            hover="hover:bg-[#f7b444]"
            @viewMore="viewDetail('Dipesan')"
          />
          <CardDetail
            menu="Jumlah Belum Dipesan"
            :detail="total.jumlah_belum_dipesan"
            :loading="total.loading"
            background="bg-red-200"
            text="text-red-800"
            bgButton="bg-red-200"
            textColor="text-red-800"
            hover="hover:bg-red-300"
            @viewMore="viewDetail('Belum Dipesan')"
          />
        </div>
      </div>

      <DetailDipesan v-if="showDetail && detailTitle == 'Dipesan'" @onClose="onClose" />

      <DetailBelumDipesan
        v-if="showDetail && detailTitle == 'Belum Dipesan'"
        @onClose="onClose"
      />

      <!-- <TestView v-if="showDetail && detailTitle == 'Belum Dipesan'" @onClose="onClose" /> -->

      <DetailScene v-if="showDetail && detailTitle == 'Scene'" @onClose="onClose" />

      <DetailPostOrder
        v-if="showDetail && detailTitle == 'Post Order'"
        @onClose="onClose"
      />

      <DetailFeature v-if="showDetail && detailTitle == 'Feature'" @onClose="onClose" />
    </MainContent>
  </div>
</template>
<script>
import CardDetail from "@/components/CardDetail.vue";
import HeaderTitle from "@/components/HeaderTitle.vue";
import IconHome from "@/components/icons/IconHome.vue";
import MainContent from "@/components/MainContent.vue";
import DetailDipesan from "./DetailDipesan.vue";
import DetailBelumDipesan from "./DetailBelumDipesan.vue";
import DetailScene from "./DetailScene.vue";
import DetailPostOrder from "./DetailPostOrder.vue";
import DetailFeature from "./DetailFeature.vue";
import { useDashboardStore, useAuthStore } from "@/store";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";
// import TestView from "./TestView.vue";

export default {
  components: {
    HeaderTitle,
    IconHome,
    MainContent,
    CardDetail,
    DetailDipesan,
    DetailBelumDipesan,
    DetailScene,
    DetailPostOrder,
    DetailFeature,
    // TestView,
  },
  setup() {
    const authStore = useAuthStore();
    const { user } = storeToRefs(authStore);
    const dashboardStore = useDashboardStore();
    const { total } = storeToRefs(dashboardStore);
    const showDetail = ref(false);

    const detailTitle = ref("");

    const getTotal = async () => {
      await dashboardStore.getTotal();
    };

    const viewDetail = (val) => {
      detailTitle.value = val;
      showDetail.value = true;
    };

    onMounted(() => {
      getTotal();
    });

    const onClose = () => {
      showDetail.value = false;
      detailTitle.value = "";
    };

    return {
      user,
      total,
      detailTitle,
      showDetail,
      viewDetail,
      onClose,
    };
  },
};
</script>
<style></style>
